const ADULT_BIRTHDAY_IMAGES = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/epzkfexc_FOTO%2028.png",
    alt: "Aniversário 18 anos - tema preto e prata",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/j0byu6l7_FOTO%2031.png",
    alt: "Aniversário 80 anos Kazimierz - azul marinho e dourado",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/6ctbz1ft_FOTO%2032.png",
    alt: "Decoração sofisticada - dourado e marrom",
  },
];

export default function AdultBirthday() {
  return (
    <section data-testid="adult-birthday-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Sonhos Realizados</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Aniversário Adulto
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-[#555555] leading-relaxed text-base">
            Comemorar não tem idade. Homens e mulheres também merecem festejar cada novo ciclo de uma forma especial. Criamos decorações personalizadas que traduzem estilos, cores e preferências em cenários únicos, para deixar cada aniversário com a personalidade de quem é o motivo da festa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ADULT_BIRTHDAY_IMAGES.map((img, i) => (
            <div
              key={i}
              className="overflow-hidden rounded-3xl hover-lift"
              data-testid={`adult-birthday-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-72 md:h-96 object-cover transition-transform duration-500 hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
